<template>
	<div class="actions-modal">
		<slot> </slot>
	</div>
</template>

<script>
	export default {
		name: 'ui-modal-actions'
	}
</script>

<style lang="stylus" scoped>
	@import './style.styl'
</style>
